import { ChevronRight } from 'react-feather';

import LinkButton from '@/shared/components/UI/LinkButton';

const ContactUsBanner = () => {
  return (
    <section className="contact-us w-full bg-[#f4ecf4] py-[60px] text-center">
      <p className="contact-us-sub-text text-sm font-medium leading-[1.6]">
        Connecting K-Culture and the World with K-MONSTAR – Get Started Now
      </p>
      <h3 className="contact-us-title mt-[12px] text-xl font-extrabold tracking-[0.05rem] text-[#95699f]">
        Let’s Kick Off Your B2B Journey
      </h3>
      <LinkButton
        to="/contact"
        variant="primary"
        className="mx-auto mt-[44px] gap-[8px] px-[20px] py-[10px] text-sm tracking-[0.1rem]"
        rightIcon={<ChevronRight size={20} />}
      >
        CONTACT US
      </LinkButton>
    </section>
  );
};

export default ContactUsBanner;
